import { styled } from "@mui/material/styles";
import type { PaperProps } from "@mui/material/Paper";
import Paper from "@mui/material/Paper";

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  maxWidth: theme.spacing(70),
  width: "100%",
}));

export default function Section({
  children,
  elevation = 0,
  variant = "outlined",
  ...props
}: React.PropsWithChildren<PaperProps>) {
  return (
    <StyledPaper elevation={elevation} variant={variant} {...props}>
      {children}
    </StyledPaper>
  );
}
